var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BootstrapButton',{staticClass:"GoToTopBtn",attrs:{"link":true},on:{"click":_vm.onBtnClick}},[_vm._v(" "+_vm._s(_vm.$t('_.to-top'))+" "),_c('span',{staticClass:"GoToTopBtn__icon",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }